import { notification } from 'antd'
import { publicAPI } from '../../Config/Constant'
import store from '../store'




export const addUserGroup = async(payload) => {
      try {
       const res = await publicAPI.post('/usergroup/add', payload)
       if (res) {
       
         if (res) {
 
           notification.success({
             description: res.data.data.message,
             duration: 2,
           })
            return res
         } 
         

       }
     } catch (err) {
       console.error('Error during login:', err); 
       notification.error({
         message: err?.response?.data?.message || 'Server Error',
         duration: 3,
       })
     }
   
 }



 export const getUserGroup = async(payload) => {
      try {
       const res = await publicAPI.get(`/usergroup/get/${payload.organizationid}`)
       if (res) {         
            store.dispatch({
                type: 'SET_USER_GROUP',
                payload: res.data.data,
              })

       
    
            return res
         

       }
     } catch (err) {
       console.error('Error during login:', err); 
       notification.error({
         message: err?.response?.data?.message || 'Server Error',
         duration: 3,
       })
     }
   
 }


 // edit

 export const editUserGroup = async(payload) => {
    try {
     const res = await publicAPI.post('/usergroup/edit', payload)

     if (res) {
     notification.success({
       description: res.data.data.message,
       duration: 2,
     })
    }
     return res
   } catch (err) {
     console.error('Error during login:', err); 
     notification.error({
       message: err?.response?.data?.message || 'Server Error',
       duration: 3,
     })
   }
 
}


export const editMultiUserGroup = async(payload) => {
 
   try {
     const res = await publicAPI.post('/usergroup/mult-edit', payload)

     if (res) {
     notification.success({
       description: res.data.data.message,
       duration: 2,
     })
    }
     return res
   } catch (err) {
     console.error('Error during login:', err); 
     notification.error({
       message: err?.response?.data?.message || 'Server Error',
       duration: 3,
     })
   }
 
}
 export const deleteUserGroup = async(payload) => {
 
   try {
     const res = await publicAPI.post('/usergroup/delete', payload)
     if (res) {

       if (res) {
         
         notification.success({
           description: res.data.data.message,
           duration: 2,
         })
          return res
       } 
       

     }
   } catch (err) {
     notification.error({
       message: err?.response?.data?.message || 'Server Error',
       duration: 3,
     })
   }
 
}

